import React from 'react';
import {InputAdornment, TextField} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

type Props = {
  searchQuery: string;
  // eslint-disable-next-line no-unused-vars
  onChangeSearch: (query: object) => void;
};

export default function SearchBar(props: Props) {
  const {searchQuery, onChangeSearch} = props;

  return (
    <TextField
      value={searchQuery}
      onChange={onChangeSearch}
      fullWidth
      InputLabelProps={{
        sx() {
          return {
            paddingLeft: '10px',
            '&.Mui-focused': {
              paddingLeft: '0px',
            },
            '&.MuiInputLabel-shrink': {
              paddingLeft: '0px',
            },
          };
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
        style: styles.InputPropStyle,
      }}
      id="outlined-basic"
      label="Search by keyword"
      variant="outlined"
    />
  );
}
const styles = {
  InputPropStyle: {
    borderRadius: '100px',
    paddingLeft: '10px',
    paddingRight: '20px',
  },
};
